import { Component, IterableDiffers, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ListViewColumnFactory } from '../../../service/factory/list-view-column-factory.service';
import { ListViewBase } from '../list-view.base';
import { DefaultPageSize, PagingEvent } from '../paging/paging.component';
import { LanguageService } from '../../../service/language.service';

@Component({
    selector: 'app-list-view',
    templateUrl: './list-view.component.html',
    styleUrls: ['./list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListViewComponent<TSource = any> extends ListViewBase<TSource> implements OnInit {
  constructor(columnFactory: ListViewColumnFactory, languageService: LanguageService, iterableDiffers: IterableDiffers) {
    super(columnFactory, languageService, iterableDiffers);
  }

  @Input() isToolbarSticky: boolean = false;
  @Input() preferencesKey: string;

  //This receives a randomized ID to scope commands/menus per list component instance (e.g., when multiple list components are on a page) so only the intended instance handles dispatched actions. - Atlan
  @Input() contextId?: string;

  from: number = 0;
  to: number = DefaultPageSize;

  ngOnInit() {}

  getRowNumber(index: number): number {
    return this.from + index + 1;
  }

  pagingChanged(e: PagingEvent) {
    this.from = e.from;
    this.to = e.to;
  }
}
